<template>
<div class="closeText">{{ close }}</div>
</template>

<script>
export default {
  data () {
    return {
      close: 'x'
    }
  },

  methods: {
  }
}
</script>

<style>
.closeText {
  border-radius: 50%;
  cursor: pointer;
  width: 26px;
  height: 26px;
  padding: 0px;
  position: absolute;
  right: 2px;
  top: 5px;
  background: #fff;
  color: #666;
  text-align: center;
  font-size: 18px;
  font-family: 'Arial';
}

.closeText:hover {
  background-color: #e7e6e6;
}
</style>



// WEBPACK FOOTER //
// src/components/CloseButton.vue